export const FIRST_LOGIN_FLOW_PATHS = {
  FIRST_LOGIN_FLOW: '/first-login-flow',
  CONNECT_TO_ORGANIZATION: '/connect-organization',
  CONNECT_TO_ORGANIZATION_SEARCH: '/connect-organization-search',
  CONNECT_TO_ORGANIZATION_RESULTS: '/connect-organization-results',
  CONNECT_TO_ORGANIZATION_TOO_MANY_RESULTS: '/connect-organization-too-many-results',
  CONNECT_TO_ORGANIZATION_NO_RESULTS: '/connect-organization-no-results',
  CONNECT_TO_ORGANIZATION_REQUEST_SENT: '/connect-organization-request-sent',
  CREATE_NEW_ORGANIZATION: '/create-new-organization',
  ORGANIZATION_CREATED: '/organization-created'
} as const
